import React from "react";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import { EmptyState } from "../EmptyState";

export function GrowthChart({ data }) {
  if (!data.length) return <EmptyState />;
  return (
    <ResponsiveContainer width="100%" height={210}>
      <LineChart data={data} margin={{ top: 20, right: 8, left: -18, bottom: 0 }}>
        <CartesianGrid vertical={false} stroke="#EEF2F7" />
        <XAxis dataKey="month" tick={{ fontSize: 11, fill: "#94A3B8" }} axisLine={false} tickLine={false} />
        <YAxis tick={{ fontSize: 11, fill: "#94A3B8" }} axisLine={false} tickLine={false} width={40} />
        <Tooltip
          contentStyle={{ borderRadius: 10, border: "1px solid #E2E8F0", fontSize: 12 }}
          formatter={(v, n) => [v, n === "headcount" ? "Headcount" : n]}
        />
        <Line
          type="monotone"
          dataKey="headcount"
          stroke="#2563EB"
          strokeWidth={2.5}
          dot={{ r: 3.5, fill: "#2563EB", strokeWidth: 0 }}
          activeDot={{ r: 5 }}
          label={{ position: "top", fontSize: 11, fill: "#1E293B", fontWeight: 600, offset: 10 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}